import { NotificationMessage } from '../common';
import { RetailKADMessageResponse } from '../services/Market.service';

export enum ActionType {
  SetIsModalOpen,
  SetNotificationMessage,
  SetMarket,
  SetActiveSlideIndex,
  SetSingleSlide,
  SetPageName,
  SetBannerNumber,
  SetRetailKADUpsellMessage,
}

export interface SetMarket {
  type: ActionType.SetMarket;
  payload: string;
}

export interface SetPageName {
  type: ActionType.SetPageName;
  payload: string;
}

export interface SetBannerNumber {
  type: ActionType.SetBannerNumber;
  payload: number;
}

export interface SetIsModalOpen {
  type: ActionType.SetIsModalOpen;
  payload: boolean;
}

export interface SetNotificationMessage {
  type: ActionType.SetNotificationMessage;
  payload?: NotificationMessage;
}

export interface SetActiveSlideIndex {
  type: ActionType.SetActiveSlideIndex;
  payload: number;
}

export interface SetSingleSlide {
  type: ActionType.SetSingleSlide;
  payload: () => React.ReactElement | null;
}

export interface SetRetailKADUpsellMessage {
  type: ActionType.SetRetailKADUpsellMessage;
  payload: RetailKADMessageResponse;
}

export const setIsModalOpen = (isModalOpen: boolean): SetIsModalOpen => ({
  type: ActionType.SetIsModalOpen,
  payload: isModalOpen,
});

export const setMarket = (market: string): SetMarket => ({
  type: ActionType.SetMarket,
  payload: market,
});

export const setPageName = (pageName: string): SetPageName => ({
  type: ActionType.SetPageName,
  payload: pageName,
});

export const setBannerNumber = (number: number): SetBannerNumber => ({
  type: ActionType.SetBannerNumber,
  payload: number,
});

export const setNotificationMessage = (notification?: NotificationMessage): SetNotificationMessage => ({
  type: ActionType.SetNotificationMessage,
  payload: notification,
});

export const setActiveSlideIndex = (index: number): SetActiveSlideIndex => ({
  type: ActionType.SetActiveSlideIndex,
  payload: index,
});

export const setShowSingleSlide = (slide?: () => React.ReactElement | null): SetSingleSlide => ({
  type: ActionType.SetSingleSlide,
  payload: slide,
});

export const SetRetailKADUpsellMessage = (cell: RetailKADMessageResponse): SetRetailKADUpsellMessage => ({
  type: ActionType.SetRetailKADUpsellMessage,
  payload: cell,
});

export type Action =
  | SetIsModalOpen
  | SetNotificationMessage
  | SetMarket
  | SetActiveSlideIndex
  | SetSingleSlide
  | SetPageName
  | SetBannerNumber
  | SetRetailKADUpsellMessage;
